import { GET_AWBS_EXPORT_SUCCEEDED } from '../actions/actionTypes';
import Awb from '../../models/Awb';

const initialState: Awb[] = [];

export const awbsExportReducer = (state:Awb[] = initialState, action: any) => {
  switch (action.type) {
    case GET_AWBS_EXPORT_SUCCEEDED:
      return [...action.payload ]; 
    default:
     return state;
  }
};
